<template>
    <div class="item">
        <div
            class="output"
            draggable="true"
            @dragstart="startDrag"
            @dragend="endDrag"
        >
            {{ result.text }}
        </div>
        <div class="label">
            <i
                class="far fa-lightbulb"
                v-b-tooltip.hover="{
                    title: 'Suggested field'
                }"
            ></i>
            <span>{{ result.label }}</span>
            <a href="#" @click.prevent="applyDirect">[Apply]</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        result: {
            type: Object,
            required: true
        }
    },
    methods: {
        startDrag(event) {
            event.target.classList.add("dragging");
            event.dataTransfer.setData("text", this.result.text);
        },
        endDrag(event) {
            event.target.classList.remove("dragging");
        },
        applyDirect() {
            let te = document.querySelector(`textarea[id="${this.result.id}"]`);
            if (te) {
                te.value = this.result.text;
                te.dispatchEvent(new Event("input"));
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.item {
    padding: 15px;

    .output {
        display: flex;
        margin-top: 5px;
        align-items: center;
        gap: 5px;
        border: 2px dashed #dedede;
        border-radius: 4px;
        cursor: grab;
        overflow: hidden;
        background: #f9f9f9;
        padding: 10px;
        line-height: 1.6em;

        &:hover {
            border-color: #b7bee5;
        }

        &.dragging {
            opacity: 0.7;
            cursor: grabbing;
            background: #fff;
            border: 2px dashed blue;
        }

        .grip {
            color: gray;
        }
    }

    .label {
        display: flex;
        gap: 10px;
        padding: 11px;
        align-items: center;

        i.fa-lightbulb {
            font-size: 1.1em;
            color: #c83e31;
        }

        span {
            font-weight: 600;
        }
    }
}
</style>
